import { css } from "@emotion/react";

import { Card } from "components/shared/library/Card";

import {
  SHIMMER_KEYFRAME,
  SHIMMER_TRANSITION_DURATION,
  SHIMMER_TRANSITION_TIMING_FUNCTION,
} from "constants/animations";
import { uiGray, white } from "constants/colors";

const style = {
  shimmer: css({
    animation: `${SHIMMER_KEYFRAME} ${SHIMMER_TRANSITION_DURATION} infinite ${SHIMMER_TRANSITION_TIMING_FUNCTION}`,
    background: `linear-gradient(to right, ${white} 4%, ${uiGray.pageBackground} 25%, ${white} 66%)`,
    backgroundSize: "1000px 100%",
    width: "-webkit-fill-available",
    flex: 1,
    overflow: "hidden",
    padding: 24,
  }),
};
export const JobDetailSkeleton = () => {
  return (
    <>
      <Card customCss={style.shimmer}>
        <svg
          data-testid="chat-content-skeleton"
          width="783"
          height="150"
          viewBox="0 0 783 150"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0"
            y="0"
            width="80%"
            height="150"
            rx="7"
            fill="url(#paint1_linear_2142_140552)"
          />

          <defs>
            <linearGradient
              id="paint1_linear_2142_140552"
              x1="398"
              y1="163.123"
              x2="96"
              y2="163.123"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#DBDBDB" stopOpacity="0.05" />
              <stop offset="0.5" stopColor="#DBDBDB" />
            </linearGradient>
          </defs>
        </svg>
      </Card>
      <Card customCss={style.shimmer}>
        <svg
          data-testid="chat-content-skeleton"
          width="783"
          height="150"
          viewBox="0 0 783 150"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0"
            y="0"
            width="80%"
            height="150"
            rx="7"
            fill="url(#paint1_linear_2142_140552)"
          />

          <defs>
            <linearGradient
              id="paint1_linear_2142_140552"
              x1="398"
              y1="163.123"
              x2="96"
              y2="163.123"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#DBDBDB" stopOpacity="0.05" />
              <stop offset="0.5" stopColor="#DBDBDB" />
            </linearGradient>
          </defs>
        </svg>
      </Card>
      <Card customCss={style.shimmer}>
        <svg
          data-testid="chat-content-skeleton"
          width="783"
          height="150"
          viewBox="0 0 783 150"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0"
            y="0"
            width="80%"
            height="150"
            rx="7"
            fill="url(#paint1_linear_2142_140552)"
          />

          <defs>
            <linearGradient
              id="paint1_linear_2142_140552"
              x1="398"
              y1="163.123"
              x2="96"
              y2="163.123"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#DBDBDB" stopOpacity="0.05" />
              <stop offset="0.5" stopColor="#DBDBDB" />
            </linearGradient>
          </defs>
        </svg>
      </Card>
      <Card customCss={style.shimmer}>
        <svg
          data-testid="chat-content-skeleton"
          width="783"
          height="150"
          viewBox="0 0 783 150"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0"
            y="0"
            width="80%"
            height="150"
            rx="7"
            fill="url(#paint1_linear_2142_140552)"
          />

          <defs>
            <linearGradient
              id="paint1_linear_2142_140552"
              x1="398"
              y1="163.123"
              x2="96"
              y2="163.123"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#DBDBDB" stopOpacity="0.05" />
              <stop offset="0.5" stopColor="#DBDBDB" />
            </linearGradient>
          </defs>
        </svg>
      </Card>
    </>
  );
};
